import React from "react";
import { Link } from "react-router-dom";
import SidebarLogout from "./SidebarLogout";
import SidebarCloseButton from "./SidebarCloseButton";

export default function AdminMenu() {
  return (
    <>
      <aside className="main-sidebar">
        <section className="sidebar position-relative">
          <SidebarCloseButton />
          <div className="multinav">
            <div className="multinav-scroll">
              <ul className="sidebar-menu" data-widget="tree">
                <li>
                  <Link to="/admin-dashboard">
                    <i className="icon-Layout-4-blocks">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Dashboard</span>
                  </Link>
                </li>

                <li>
                  <Link to="/view-doctors">
                    <i className="icon-Barcode-read">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">View Doctors</span>
                  </Link>
                </li>

                {/* <li>
                  <Link to="/add-case">
                    <i className="icon-Barcode-read">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Add New Case</span>
                  </Link>
                </li> */}
                <li>
                  <Link to="/view-cases?r_type=patient">
                    <i className="icon-Compiling">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">View Submitted Cases</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to="/view-cases?r_type=all">
                    <i className="icon-Settings-1">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Reports</span>
                  </Link>
                </li> */}
                <li>
                  <Link to="/bp-reports?r_type=all">
                    <i className="icon-Settings-1">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">BP Reports</span>
                  </Link>
                </li>
                <li>
                  <Link to="/upload-files">
                    <i className="ti-upload" aria-hidden="true" />
                    <span className="sidebar-menu__label">Upload Files</span>
                  </Link>
                </li>
                <li className="">
                <Link to="/instructions">
                    <i className="icon-Diagnostics">
                      <span className="path1"></span>
                      <span className="path2"></span>
                      <span className="path3"></span>
                    </i>
                    <span className="sidebar-menu__label">Instructions</span>
                  </Link>
                </li>
                {/* <li className="header">Reports</li> */}
                <li>
                  <Link to="/contact">
                    <i className="icon-Library">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Contact</span>
                  </Link>
                </li>
                <li>
                  <Link to="/change-password">
                    <i className="icon-Lock-overturning">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Change Password</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to="#">
                    <i className="icon-Library">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">FAQ</span>
                  </Link>
                </li> */}

                {/* <li className="treeview">
                  <a href="#">
                    <i className="icon-Lock-overturning">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                    <span className="sidebar-menu__label">Accout Settings</span>
                    <span className="pull-right-container">
                      <i className="fa fa-angle-right pull-right"></i>
                    </span>
                  </a>
                  <ul className="treeview-menu">
                    <li>
                      <a href="#">
                        <i className="icon-Commit">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                        My Profile
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="icon-Commit">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                        Edit Profile
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="icon-Commit">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                        Change Password
                      </a>
                    </li>
                   
                  </ul>
                </li> */}
              </ul>
              <SidebarLogout />
            </div>
          </div>
        </section>
      </aside>
    </>
  );
}
